import { Injectable, inject } from '@angular/core';
import { Product } from 'src/app/Shared/models/product.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CartItem } from 'src/app/Shared/models/cart-item';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HomePageService } from 'src/app/Customer/services/home-page.service';
import { MatDialog } from '@angular/material/dialog';
import { WishListDialogComponent } from 'src/app/Customer/components/product-related/wish-list-dialog/wish-list-dialog.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { CommonService } from './common.service';

function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class CartService {
  snackBar = inject(MatSnackBar);
  private http = inject(HttpClient);
  private homePageService = inject(HomePageService);
  private dialog = inject(MatDialog);
  private commonService = inject(CommonService);

  message: any
  //latest value of guest cart items for use in this service so that we don't need to subscribe whenever we want items in this service
  guestCartItems: CartItem[] = JSON.parse(localStorage.getItem("cartItem")) || [];
  //subject emmitting latest guest cart items
  guestCartItemsSubject: BehaviorSubject<CartItem[]> = new BehaviorSubject(this.getGuestCartItems());
  //cartItemsCount subject for both guest and systemUser
  /*For system user when we subscribe to this subject we get guest cart count but we will end up calling
  FetchCartItemsForSystemUser() anyways initially, so it will be replaced with the system user cart count*/
  cartItemsCount: BehaviorSubject<number> = new BehaviorSubject(this.guestCartItems.length);
  // apiUrl = environment.apiUrl
  apiUrl = environment.apiUrl;
  onDestroy$ = new Subject<boolean>();
  private fasBeetleUrl = 'https://dev.fastbeetle.com';
  siteId: any
  constructor() {
    this.siteId = this.homePageService.configurations?.site;
  }

  get nativeWindow(): any {
    return _window();
  }

  //get guest cart items subject
  getGuestCartItemsSubject() {
    return this.guestCartItemsSubject;
  }

  //get guest cart items. For components which do not care about the changes to cart items
  getGuestCartItems() {
    //getting from localStorage to handle two tab scenario
    this.guestCartItems = JSON.parse(localStorage.getItem("cartItem")) || [];
    //returns a deep copy of guest items to avoid undesirable changes to cart items outside this service
    return this.guestCartItems.map(cartItem => { return { ...cartItem } });
  }

  //get guest cart items count
  getGuestCartItemsCount() {
    return this.guestCartItems.length;
  }

  //add to cart for guest
  addToCartGuest(product: Product, quantity: number) {
    var item: CartItem | boolean = false;
    if (!localStorage.getItem("currentUser")) {
      let hasItem = this.guestCartItems.find((cartItem, index) => {
        // If cartItem exists
        const availQuant = this.guestCartItems[index].quantity + quantity
        if (cartItem.product.catalogItem == product.catalogItem && cartItem.product.catalogItemStyle == product.catalogItemStyle) {
          if (availQuant > product.quantityinHand && !product.backorder) {
            const qty = product.quantityinHand - this.guestCartItems[index].quantity
            this.message = `Item is already in your cart, total quantity of item exceeds available quantity. Available Quantity: ${qty}`
          } else if (availQuant > (product.backOrderQuantityLimit + product.quantityinHand) && product.backorder) {
            const qty = (product.backOrderQuantityLimit + Number(product.quantityinHand)) - this.guestCartItems[index].quantity
            this.message = `Item is already in your cart, total quantity of item exceeds available quantity. Available Quantity: ${qty}`
          } else {
            this.message = ""
            this.guestCartItems[index].quantity += quantity;
          }
          return true;

        } else return false;
      });
      // If cartItem does not exist (Add New cartItem)
      if (!hasItem) {
        item = { product: product, quantity: Number(quantity) };
        this.guestCartItems.push(item);
        // this.openDialog(product, quantity)
      }

      this.emitNewData();

      return item;
    }
  }

  //remove from cart for guest
  removeFromCartGuest(item: CartItem) {
    if (item === undefined) return false;
    this.guestCartItems.splice(this.guestCartItems.indexOf(item), 1);
    this.emitNewData();
  }

  //clear cart for guest
  clearCartGuest() {
    this.guestCartItems = [];
    localStorage.removeItem("cartItem");
    //emit new cart items
    this.guestCartItemsSubject.next([]);
    //emit new cart items count
    this.setCartItemsCount(0)
  }

  // total cart amount guest
  getGuestTotalAmount() {
    //return the subject so that whenever the cart items change the total amount also changes
    return this.guestCartItemsSubject.pipe(map((product: CartItem[]) => {
      return this.guestCartItems.filter((item) => item?.product?.isChecked).reduce((prev, curr: CartItem) => {
        return prev + curr.product.price * curr.quantity;
      }, 0);
    }));
  }
  getGuestTotalDiscountAmount() {
    //return the subject so that whenever the cart items change the total amount also changes
    return this.guestCartItemsSubject.pipe(map((product: CartItem[]) => {
      return this.guestCartItems.filter((item) => item?.product?.isChecked).reduce((prev, curr: CartItem) => {
        return prev + curr.product.priceTier.priceTier[curr.product.priceTier.priceTier.length - 1].discountRate * curr.quantity;
      }, 0);
    }));
  }

  fetchCountry() {
    return this.http.get(`${this.apiUrl}WebOrder/FetchCountryForSite`)
  }

  fetchState(country: any) {
    return this.http.get(`${this.apiUrl}WebOrder/FetchStateForCountry?countryX=${country}`)
  }
  // not in use
  // SaveBillingAddress(address: any) {
  //   return this.http.post(`${this.apiUrl}Cart/SaveBillingAddress`, address)
  // }

  SaveShippingAddress(address: any, webOrder: any) {
    return this.http.post(`${this.apiUrl}WebOrder/SaveShippingAddress?webOrder=${webOrder}`, address)
  }
  updateAddress(address: any) {
    return this.http.put(`${this.apiUrl}WebOrder/UpdateAddress`, address)
  }
  saveWebOrder(model: any) {
    return this.http.post(`${this.apiUrl}WebOrder/SaveDetail`, model)
  }

  FetchForCatalogItemInStock(catalogItem) {
    const currentUser = localStorage.getItem("currentUser");
    const queryParams: any = { catalogItem: catalogItem };
    if (!currentUser) {
      queryParams.isGuest = true;
    }
    return this.http.get(`${this.apiUrl}WebOrder/FetchCatalogItemInStockOnly`, { params: queryParams });
  }
  FetchShippingMethod() {
    return this.http.get(`${this.apiUrl}WebOrder/FetchShippingMethod`)
  }

  SaveShippingMethod(model: any) {
    let params = new HttpParams();
    // params = params.append('systemUser', model?.systemUser)
    // params = params.append('siteCatalog', model?.siteCatalog)
    params = params.append('shippingMethod', model?.shippingMethod)
    params = params.append('webOrder', model?.webOrder)
    // params = params.append('expeditedFFee', model?.expeditedFFee)
    // params = params.append('expeditedService', model?.expeditedService)
    return this.http.put(`${this.apiUrl}WebOrder/SaveShippingMethod`, null, { params: params })
  }

  FetchOrderHistory(webOrder) {
    let params = new HttpParams();
    params = params.append('webOrder', webOrder)
    // params = params.append('systemUser', systemUser)
    return this.http.get(`${this.apiUrl}WebOrder/FetchHistory`, { params: params })
  }
  // not in use
  // fetchIncompleteOrderHistory(model: any) {
  //   return this.http.get(`${this.apiUrl}Cart/FetchIncompleteForSystemUserAndSite`, { params: model })
  // }

  ProcessRequestOrder(model: any) {
    return this.http.post(`${this.apiUrl}Payment/ProcessRequestOrder`, model)
  }

  CompleteOrderProcess(model: any) {
    // let params = new HttpParams();
    // params = params.append('webOrder', model.webOrder)
    // params = params.append('paymentId', model.razorpay_payment_id)
    // params = params.append('signature', model.razorpay_signature)
    // params = params.append('orderId', model.razorpay_order_id)

    return this.http.post(`${this.apiUrl}Payment/CompleteOrderProcess`, null, { params: model })
  }

  SavePaymentType(model: any) {
    let params = new HttpParams();
    // params = params.append('systemUser', model.systemUser)
    params = params.append('webOrder', model.webOrder)
    params = params.append('paymentType', model.paymentType)
    return this.http.put(`${this.apiUrl}WebOrder/SavePaymentType`, null, { params: params })
  }

  fetchAddresses() {
    // systemUser: any
    // ?systemUser=${systemUser}
    return this.http.get(`${this.apiUrl}WebOrder/FetchAddressForSystemUser`)
  }

  getAddress(model: any) {
    return this.http.get(`${this.apiUrl}WebOrder/FetchSingleAddress?systemUserAddress=${model.systemUserAddress}`)
  }
  // change pending
  deleteAddress(systemUserAddress) {
    return this.http.delete(`${this.apiUrl}WebOrder/${systemUserAddress}`)
  }
  // not in use
  // selectExistingBillingAddress(model) {
  //   return this.http.post(`${this.apiUrl}Cart/SelectBillingAddress`, null, { params: model })
  // }

  // selectExistingShippingAddress(model) {
  //   return this.http.post(`${this.apiUrl}Cart/SelectShippingAddress`, null, { params: model })
  // }
  selectExistingAddress(model) {
    return this.http.post(`${this.apiUrl}WebOrder/SelectAddress`, null, { params: model })
  }

  // not in use
  // cancelOrder(model) {
  //   return this.http.delete(`${this.apiUrl}Cart/CancelWebOrder?systemUser=${model.systemUser}&webOrder=${model.webOrder}`);
  // }

  // FetchWebOrderForSystemUser(model: any) {
  //   let params = new HttpParams();
  //   params = params.append('orderType', model.orderType)
  //   params = params.append('pageNumber', model.pageNumber)
  //   params = params.append('pageSize', model.pageSize)
  //   return this.http.get(`${this.apiUrl}WebOrder/FetchWebOrderForSystemUser`, { params: params })
  // }

  confirmOrder(model) {
    return this.http.put(`${this.apiUrl}WebOrder/FinancialCommit`, null, { params: model })
  }

  AddItemToCartForSystemUser(model: any) {
    return this.http.post(`${this.apiUrl}Cart`, model)
  }

  FetchCartItemsForSystemUser() {
    // console.log(model)
    // let params = new HttpParams();
    // params = params.append('pageNumber', model?model.pageNumber:1)
    // params = params.append('pageSize', model?model.pageSize:1)
    return this.http.get(`${this.apiUrl}Cart`)
  }

  ChangePassword(model: any) {
    let params = new HttpParams();
    // params = params.append('SystemUser', model.SystemUser)
    params = params.append('OldPassword', model.oldPassword)
    params = params.append('NewPassword', model.newPassword)
    return this.http.post(`${this.apiUrl}Accounts/SystemUser/ChangePassword`, null, { params: params })
  }

  deleteCartItem(model) {
    return this.http.delete(`${this.apiUrl}Cart/${model.shoppingCart}`);
  }

  updateCartItem(model) {
    return this.http.put(`${this.apiUrl}Cart`, model)
  }

  // Update cart quantity for a guest cart item
  updateCartQuantity(newQuantity: number, index: number) {
    this.guestCartItems[index].quantity = newQuantity;
    this.emitNewData();
  }

  FetchWebOrderForSystemUserAndSearch(model) {
    let params = new HttpParams();
    // params = params.append('siteId', model.siteId)
    // params = params.append('systemUser', model.systemUser)
    params = params.append('searchHint', model.searchHint)
    params = params.append('pageNumber', model.pageNumber)
    params = params.append('pageSize', model.pageSize)
    params = params.append('orderType', model.orderType)
    return this.http.get(`${this.apiUrl}WebOrder/FetchWebOrderForSystemUserAndSearch`, { params: params })
  }

  // FetchShippingAddress(model) {
  //   let params = new HttpParams();
  //   params = params.append('systemUser', model.systemUser)
  //   params = params.append('systemUserAddress', model.systemUserAddress)
  //   return this.http.get(`${this.apiUrl}Cart/FetchShippingAddress`, { params: params })
  // }

  WebOrderQuantity(model) {
    return this.http.put(`${this.apiUrl}WebOrder/UpdateQuantity`, null, { params: model })
  }

  FetchWebOrderForSystemUserByDate(model) {
    let params = new HttpParams();
    // params = params.append('siteId', model.siteId)
    // params = params.append('systemUser', model.systemUser)
    params = params.append('isArchieved', model.isArchieved)
    params = params.append('orderType', model.orderType)
    params = params.append('pageNumber', model.pageNumber)
    params = params.append('pageSize', model.pageSize)
    params = params.append('startDate', model.startDate)
    params = params.append('endDate', model.endDate)
    return this.http.get(`${this.apiUrl}WebOrder/FetchWebOrderForSystemUserByDate`, { params: params })
  }

  FetchCartItemById(model: any) {
    return this.http.get(`${this.apiUrl}Cart/${model.item}`)
  }

  SetDefaultAddressForSystemUser(model: any) {
    return this.http.put(`${this.apiUrl}WebOrder/SetDefaultAddress`, null, { params: model })
  }
  //change  pending from backend
  FetchDefaultAddressForSystemUser() {
    return this.http.get(`${this.apiUrl}WebOrder/FetchDefaultAddressForSystemUser`)
  }

  //--------------------------Order Item QandA methods-----------------------
  //Fetches FAQ of a specific item of a specific order from a specific page of a specific size. The response should also contain a field for totalFAQ
  fetchOrderItemFAQS(itemId: number, pageNumber: number, pageSize: number) {
    let params = new HttpParams({
      fromObject: {
        webOrderDetail: itemId,
        pageNumber: pageNumber,
        pageSize: pageSize
      }
    });
    return this.http.get(`${this.apiUrl}Vendor/WebOrder/FAQ`, { params: params });
  }
  //fozia will change
  //adds a new question asked by a customer to his/her item of a particular order
  addQuestionToOrderItem(orderId: number, itemId: number, question: string) {
    const reqBody = {
      // "webOrderFAQ": 0,
      "questionX": question,
      // "answerX": null, //sending this null for new question is important
      "webOrder": orderId,
      "webOrderDetail": itemId,
      "isQuestionUpdated": false
    };
    return this.http.post(`${this.apiUrl}Vendor/WebOrder/FAQ`, reqBody);
  }
  webOrderConservation(messageModel) {
    return this.http.post(`${this.apiUrl}WebOrder/conversation`, messageModel);
  }
  getConversations(webOrderDetail, webOrder, catalogItem, catalogItemStyle, recipientEmail
  ) {
    let params = {
      // webOrderDetail: null,
      // webOrder: null,
      catalogItem: catalogItem,
      catalogItemStyle: catalogItemStyle,
      recipient: recipientEmail

    };
    return this.http.get(`${this.apiUrl}WebOrder/Conversations`, { params: params });
  }
  archiveOrder(model) {
    return this.http.put(`${this.apiUrl}WebOrder/IsArchieved`, null, { params: model })
  }

  FetchOrders(model) {
    let params = new HttpParams();
    // params = params.append('siteId', model.siteId)
    // params = params.append('systemUser', model.systemUser)
    params = params.append('orderType', model.orderType)
    params = params.append('IsArchieved', model.isArchived)
    // params = params.append('IsAdmin', model.IsAdmin)
    // params = params.append('IsSuperAdmin', model.IsSuperAdmin)
    params = params.append('pageNumber', model.pageNumber)
    params = params.append('pageSize', model.pageSize)
    return this.http.get(`${this.apiUrl}WebOrder/FetchWebOrderForSystemUser`, { params: params })
  }

  //emits new data to subscribers and sets localstorage whenever guestCartItems change
  emitNewData() {
    //set new cart items
    localStorage.setItem("cartItem", JSON.stringify(this.guestCartItems));
    //emit new cart items
    this.guestCartItemsSubject.next([...this.guestCartItems]);
    //emit new cart items count
    this.setCartItemsCount(this.guestCartItems.length)
  }

  //returns cart count subject(used for both guest and system user)
  getCartItemsCount() {
    return this.cartItemsCount;
  }

  //emits new cart count(used for both guest and system user)
  setCartItemsCount(count: number) {
    this.cartItemsCount.next(count);
  }

  getStyles(catalogItem) {
    return this.http.get(`${this.apiUrl}WebOrder/getStyles?catalogItem=${catalogItem}`)
  }
  FetchPaymentTypeForSite() {
    return this.http.get(`${this.apiUrl}WebOrder/FetchPaymentTypeForSite`)
  }
  getStyleForVariant(catalogItem, property) {
    const queryParams = property.map(element => {
      const key = Object.keys(element)[0];
      const value = element[key];
      return `${key}=${value}`;
    }).join('&');
    return this.http.get(`${this.apiUrl}WebOrder/FetchForStyleKey/${catalogItem}?${queryParams}`)
  }
  getPricingForVariant(catalogItem, property) {
    const queryParams = property.map(element => {
      const key = Object.keys(element)[0];
      const value = element[key];
      return `${key}=${value}`;
    }).join('&');
    return this.http.get(`${this.apiUrl}WebOrder/FetchForStyle/${catalogItem}?${queryParams}`)
  }
  FetchOrderDetails(webOrderDetail) {
    let params = new HttpParams();
    params = params.append('webOrderDetails', webOrderDetail)
    return this.http.get(`${this.apiUrl}WebOrder/FetchOrderDetailsByWebOrderDetails`, { params: params })
  }
  FetchCancelledOrders(model) {
    let params = new HttpParams();
    params = params.append('orderState', model.orderState)
    params = params.append('pageNumber', model.pageNumber)
    params = params.append('pageSize', model.pageSize)
    return this.http.get(`${this.apiUrl}WebOrder/FetchWebOrderDetailsByStateForSystemUser`, { params: params })
  }
  cancelItem(webOrderDetail) {
    return this.http.put(`${this.apiUrl}WebOrder/cancelOrder/${webOrderDetail}`, null)
  }
  returnOrReplace(model, formData) {
    return this.http.put(`${this.apiUrl}WebOrder/ProcessReturnAndRefund`, formData, { params: model })
  }
  FetchAcceptReturnOrReplacement(webOrderDetail) {
    return this.http.get(`${this.apiUrl}WebOrder/FetchAcceptReturnOrReplacement?webOrderDetail=${webOrderDetail}`)
  }
  fetchReturnReplacementStatus(webOrderDetail) {
    return this.http.get(`${this.apiUrl}WebOrder/FetchReturnReplacementStatus?webOrderDetail=${webOrderDetail}`)
  }
  addBankDetails(model) {
    return this.http.post(`${this.apiUrl}WebOrder/AddSystemUserRefundAccountDetails`, model)
  }
  getPickupAddresses() {
    return this.http.get(`${this.apiUrl}WebOrder/FetchAllSystemUserPickUpAddress`)
  }
  deletePickupAddress(systemUserPickUpAddress) {
    return this.http.delete(`${this.apiUrl}WebOrder/DeleteSystemUserPickUpAddress?systemUserPickUpAddress=${systemUserPickUpAddress}`)
  }
  savePickupAdd(model) {
    return this.http.post(`${this.apiUrl}WebOrder/AddSystemUserPickupAddress`, model)
  }
  getPickupAddress(address) {
    return this.http.get(`${this.apiUrl}WebOrder/FetchSystemUserPickUpAddress?systemUserpickUpAddress=${address}`)
  }
  updatePickupAddress(model) {
    return this.http.put(`${this.apiUrl}WebOrder/UpdateSystemUserPickupAddress`, model)
  }
  cancelreturn(webOrderDetail) {
    return this.http.post(`${this.apiUrl}WebOrder/cancelReturnReplacement?webOrderDetail=${webOrderDetail}`, null)
  }
  FetchWebOrderShippingStatus(webOrderDetail) {
    return this.http.get(`${this.apiUrl}WebOrder/FetchWebOrderShippingStatus?webOrderDetail=${webOrderDetail}`)
  }

  FetchTransactionHistoryForWebOrderDetail(webOrderDetail) {
    return this.http.get(`${this.apiUrl}WebOrder/FetchTransactionHistoryForWebOrderDetail?webOrderDetail=${webOrderDetail}`)
  }
  saveShippingCharges(model) {
    return this.http.put(`${this.apiUrl}WebOrder/saveShippingCharges?webOrder=${model.webOrder}&shippingCharges=${model.shippingCharges}`, null)
  }
  checkCartItems(catalogItemStyles) {
    return this.http.get(`${this.apiUrl}Cart/CheckCatalogItemStylesInCart?catalogItemStyles=${catalogItemStyles}`)
  }
  refund(model: any, webOrder: number, webOrderDetail: number) {
    return this.http.post(`${this.apiUrl}Payment/Refund`, model, { params: { webOrder: webOrder, webOrderDetail: webOrderDetail } })

  }

}
